import React from "react";
import { useI18next } from "gatsby-plugin-react-i18next";

import {MantineProvider} from "@mantine/core";
import { getDirection, isRtlLanguage } from "../utils/rtl";

const LATIN_FONT = "Montserrat";
const HEBREW_FONT = "Assistant, Arial, Helvetica, sans-serif";

const WithProvider = (props) => {
	const { language } = useI18next();
	return (<MantineProvider
			theme={{
				fontFamily: isRtlLanguage(language) ? HEBREW_FONT : LATIN_FONT,
				primaryColor: "lime",
				dir: getDirection(language),
			}}
		>
			{props.children}
		</MantineProvider>);
};

export default WithProvider;